import { render, staticRenderFns } from "./ListOfQuestions.vue?vue&type=template&id=c133f69e&scoped=true&"
import script from "./ListOfQuestions.vue?vue&type=script&lang=ts&"
export * from "./ListOfQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./ListOfQuestions.vue?vue&type=style&index=0&id=c133f69e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c133f69e",
  null
  
)

export default component.exports